import { TRACKERS } from "@/constants/Trackers";
import { TaskList } from "@/features/TaskList/TaskList";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/task-list")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_TASK_LIST);
  },
});

function RouteComponent() {
  return <TaskList />;
}
